import React from 'react';

import mainPageConfig from '../config/mainPageConfig';
import { usePageStore } from '../store/pageStore/context/pageContext';

const usePageConfig = (pageName: string): void => {
    const pageConfig = mainPageConfig[pageName];
    const { pageActions } = usePageStore();

    React.useEffect(() => {
        if (pageConfig) {
            pageActions.pageConfig.setPageConfig({ pageName, pageConfig });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default usePageConfig;
